import { APP_NAME, LOGO_DARK_BG } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const sizeClass = small ? "h-4 w-auto" : "h-5 w-auto";
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9" alt={APP_NAME} title={APP_NAME} src={`${src}?type=icon`} />
        ) : (
          <>
            <img className={classNames(sizeClass, "dark:hidden")} alt={APP_NAME} title={APP_NAME} src={src} />
            <img
              className={classNames(sizeClass, "hidden dark:inline")}
              alt={APP_NAME}
              title={APP_NAME}
              src={LOGO_DARK_BG}
            />
          </>
        )}
      </strong>
    </h3>
  );
}
